module.exports = __webpack_public_path__ + "static/media/KMH_4892.b9f487e7.jpg";